import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DwComponentSectionConfigPreference } from '@devwareapps/devware-cap';
import { RequiredAcsCodesGridConfig } from './required-acs-codes-grid.config';

@Component({
  selector: 'app-required-acs-codes-grid-config',
  template: `
    <div *ngIf="section?.config">
      <label>
        <input type="checkbox" [(ngModel)]="section.config.requireMissedCodeWhenKnowledgeScoreBelow100"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onSectionChange()">
        Require a missed ACS code when the knowledge test score is below 100%
      </label>
      <p>Applies only to Flight School Applicant forms while this section and its ACS grid are visible.</p>
    </div>
  `
})
export class RequiredAcsCodesGridConfigComponent {
  private currentSection: DwComponentSectionConfigPreference<RequiredAcsCodesGridConfig>;

  @Output() sectionChange = new EventEmitter<DwComponentSectionConfigPreference<RequiredAcsCodesGridConfig>>();

  @Input()
  get section(): DwComponentSectionConfigPreference<RequiredAcsCodesGridConfig> {
    return this.currentSection;
  }

  set section(value: DwComponentSectionConfigPreference<RequiredAcsCodesGridConfig>) {
    this.currentSection = value;
    this.setupComplete();
  }

  // CAP's dynamic configuration host sets section and then calls setupComplete.
  // This toggle needs no metadata lookup; initialize as soon as section arrives.
  setupComplete(): void {
    if (!this.section) {
      return;
    }
    this.section.config = {
      requireMissedCodeWhenKnowledgeScoreBelow100: false,
      ...(this.section.config || {})
    };
  }

  onSectionChange(): void {
    this.sectionChange.emit(this.section);
  }
}
